
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import { useNotification } from "../Notification/notification";
import "./SignIn.css";

export default function SignIn() {
  const navigate = useNavigate();
  const { notify } = useNotification();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const togglePassword = () => setShowPassword((prev) => !prev);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      return notify("Please fill all fields", "error");
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email.trim().toLowerCase(),
          password: formData.password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        return notify(data.message || "Login failed", "error");
      }

      // ✅ Save session
      localStorage.setItem("currentUser", JSON.stringify(data.user));

      notify("Login successful!", "success");

      navigate("/");
    } catch (error) {
      console.error("LOGIN ERROR:", error);
      notify("Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.body.classList.add("auth-page");
    return () => document.body.classList.remove("auth-page");
  }, []);

  return (
    <>
    <div className="auth-wrapper">

      {/* LEFT */}
      <div className="auth-left">
        <img src="/Logo/updated-logo.png" alt="logo" />
        <h1>Sulav Sewa</h1>
        <p>Smart & Reliable Home Services</p>
      </div>

      {/* RIGHT */}
      <div className="auth-right">
        <div className="auth-card">
          <h3>Sign In</h3>
          <p className="sub">Welcome back 👋</p>

          <form onSubmit={handleSubmit}>

            {/* EMAIL */}
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
            />

            {/* PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                autoComplete="current-password"
              />

              <span onClick={togglePassword}>
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>

            <button className="btn-primary" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p className="switch">
            New user? <Link to="/signup">Create account</Link>
          </p>
        </div>
     
      </div>
   
    </div>
      <button className="back-btn-bottom" onClick={() => navigate(-1)}>
    ← Back
  </button>
  </>
  );
}